import React, { useId, useState } from "react";

const InfoTooltipButton = ({ content, label = "More information" }) => {
  const tooltipId = useId();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <span className={`event-analytics-preview__tooltip ${isOpen ? "is-open" : ""}`}>
      <button
        aria-describedby={tooltipId}
        aria-expanded={isOpen}
        aria-label={label}
        className="event-analytics-preview__tooltip-button"
        onBlur={() => setIsOpen(false)}
        onClick={() => setIsOpen(true)}
        onFocus={() => setIsOpen(true)}
        onKeyDown={(event) => {
          if (event.key === "Escape") {
            setIsOpen(false);
          }
        }}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        type="button"
      >
        <span aria-hidden="true">?</span>
      </button>

      <span
        aria-hidden={!isOpen}
        className="event-analytics-preview__tooltip-bubble"
        id={tooltipId}
        role="tooltip"
      >
        {content}
      </span>
    </span>
  );
};

export default InfoTooltipButton;
